//import * as React from 'react';
import Box from '@mui/material/Box';
import {Artifacts, CardType, INodeStepsDetails, IStepDetail, newDocumentCategories} from 'app/types/Shared';
import {Alert, Stack, Tab, Tabs, Typography, useTheme} from '@mui/material';
import ReactMarkdown from 'react-markdown';
//import {IVideoCard, INodeStepDetails, IDocumentCard, IProcessCard, IProcessMapNode} from 'app/types/Shared';
import RACIBadgedRole from './RACIBadgedRole';
import WarningIcon from '@mui/icons-material/Warning';
import AlertTitle from '@mui/material/AlertTitle';
import {ArtifactCards} from 'components/ArtifactCards';
import React from 'react';
import TabPanel from 'components/ProcessDetailsPage/TabPanel';
import {ArtifactCard} from 'components/ArtifactCards/ArtifactCard';
import {Close} from '@mui/icons-material';
import {EmptyState} from 'components/EmptyState/EmptyState';

type PopUpProps = {
  nodeDetails: INodeStepsDetails;
  storybook: boolean;
};

type PanelProps = {
  stepDetails: IStepDetail;
  storybook: boolean;
};

const StepDetailsPanel = ({stepDetails, storybook}: PanelProps) => {
  const makeUnique = (artifactArray?: Artifacts[]) =>
    artifactArray?.reduce((acc, curr) => {
      if (!acc.some((item) => item.artifact.id === curr.artifact.id)) {
        acc.push(curr);
      }
      return acc;
    }, [] as Artifacts[]);
  const governingStandardProcessDocs = makeUnique(
    stepDetails.step.artifacts?.filter((a) =>
      a.artifact.j_process_artifact
        ?.map(
          (jpa) =>
            jpa.document_category === newDocumentCategories.GoverningStandardProcess &&
            stepDetails.step.process_key === jpa.process.process_id,
        )
        .includes(true),
    ),
  );
  const keyProcessBusinessControlledDocs = makeUnique(
    stepDetails.step.artifacts?.filter((a) =>
      a.artifact.j_process_artifact
        ?.map(
          (jpa) =>
            jpa.document_category === newDocumentCategories.KeyProcessBusinessControlled &&
            stepDetails.step.process_key === jpa.process.process_id,
        )
        .includes(true),
    ),
  );
  const keyProcessGxPDocs = makeUnique(
    stepDetails.step.artifacts?.filter((a) =>
      a.artifact.j_process_artifact
        ?.map(
          (jpa) =>
            jpa.document_category === newDocumentCategories.KeyProcessGxP &&
            stepDetails.step.process_key === jpa.process.process_id,
        )
        .includes(true),
    ),
  );
  const referencedDocs = makeUnique(
    stepDetails.step.artifacts?.filter((a) =>
      a.artifact.j_process_artifact
        ?.map(
          (jpa) =>
            jpa.document_category === newDocumentCategories.Referenced &&
            stepDetails.step.process_key === jpa.process.process_id,
        )
        .includes(true),
    ),
  );
  return (
    <>
      {!!stepDetails.step.raci.length && (
        <Typography variant='h5' fontWeight={700} py='10px'>
          RACI:
        </Typography>
      )}
      <RACIBadgedRole step={stepDetails.step.raci}></RACIBadgedRole>
      {stepDetails.step.details && <ReactMarkdown>{stepDetails.step.details}</ReactMarkdown>}
      {!!governingStandardProcessDocs?.length && (
        <React.Fragment>
          <Typography variant='h5' fontWeight={700} my={1.5}>
            {newDocumentCategories.GoverningStandardProcess}
          </Typography>
          <Stack spacing={1}>
            {governingStandardProcessDocs.map(({artifact}, index) => (
              <React.Fragment key={artifact.key + index}>
                {storybook ? (
                  <ArtifactCard
                    data={{
                      ...artifact,
                      parent_process_id: stepDetails.step.process_key,
                      created_dt: artifact.created_dt.substring(0, 10), // truncate to date
                      card: CardType.document,
                    }}
                    pinned={true}
                  />
                ) : (
                  <ArtifactCards
                    data={{
                      ...artifact,
                      parent_process_id: stepDetails.step.process_key,
                      created_dt: artifact.created_dt.substring(0, 10), // truncate to date
                      card: CardType.document,
                    }}
                  />
                )}
              </React.Fragment>
            ))}
          </Stack>
        </React.Fragment>
      )}
      {!!keyProcessGxPDocs?.length && (
        <React.Fragment>
          <Typography variant='h5' fontWeight={700} my={1.5}>
            {newDocumentCategories.KeyProcessGxP}
          </Typography>
          <Stack spacing={1}>
            {keyProcessGxPDocs.map(({artifact}, index) => (
              <React.Fragment key={artifact.key + index}>
                {storybook ? (
                  <ArtifactCard
                    data={{
                      ...artifact,
                      parent_process_id: stepDetails.step.process_key,
                      created_dt: artifact.created_dt.substring(0, 10), // truncate to date
                      card: CardType.document,
                    }}
                    pinned={true}
                  />
                ) : (
                  <ArtifactCards
                    data={{
                      ...artifact,
                      parent_process_id: stepDetails.step.process_key,
                      created_dt: artifact.created_dt.substring(0, 10), // truncate to date
                      card: CardType.document,
                    }}
                  />
                )}
              </React.Fragment>
            ))}
          </Stack>
        </React.Fragment>
      )}
      {!!keyProcessBusinessControlledDocs?.length && (
        <React.Fragment>
          <Typography variant='h5' fontWeight={700} my={1.5}>
            {newDocumentCategories.KeyProcessBusinessControlled}
          </Typography>
          <Stack spacing={1}>
            {keyProcessBusinessControlledDocs.map(({artifact}, index) => (
              <React.Fragment key={artifact.key + index}>
                {storybook ? (
                  <ArtifactCard
                    data={{
                      ...artifact,
                      parent_process_id: stepDetails.step.process_key,
                      created_dt: artifact.created_dt.substring(0, 10), // truncate to date
                      card: CardType.document,
                    }}
                    pinned={true}
                  />
                ) : (
                  <ArtifactCards
                    data={{
                      ...artifact,
                      parent_process_id: stepDetails.step.process_key,
                      created_dt: artifact.created_dt.substring(0, 10), // truncate to date
                      card: CardType.document,
                    }}
                  />
                )}
              </React.Fragment>
            ))}
          </Stack>
        </React.Fragment>
      )}
      {!!referencedDocs?.length && (
        <Box my={2}>
          <Typography variant='h5' fontWeight={700} my={1.5}>
            {newDocumentCategories.Referenced}
          </Typography>
          <Stack spacing={1}>
            {referencedDocs.map(({artifact}, index) => (
              <React.Fragment key={artifact.key + index}>
                {storybook ? (
                  <ArtifactCard
                    data={{
                      ...artifact,
                      created_dt: artifact.created_dt.substring(0, 10), // truncate to date
                      card: CardType.document,
                    }}
                    pinned={true}
                  />
                ) : (
                  <ArtifactCards
                    data={{
                      ...artifact,
                      created_dt: artifact.created_dt.substring(0, 10), // truncate to date
                      card: CardType.document,
                    }}
                  />
                )}
              </React.Fragment>
            ))}
          </Stack>
        </Box>
      )}
    </>
  );
};

const StepDetailsPopUp: React.FC<PopUpProps> = ({nodeDetails, storybook = false}: PopUpProps) => {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (event) setValue(newValue);
  };

  const hostName = (id: string) => {
    const host = window.location.host;
    switch (host) {
      case 'elevate-test.takeda.io':
        return '';
      case 'elevate.takeda.io':
        return '';
      default:
        return id;
    }
  };

  return (
    <div style={{height: '90%'}}>
      <Box width={420} role='presentation' height='100%'>
        {nodeDetails.steps.length > 0 ? (
          <>
            <Typography variant='h5' fontWeight={700} p={1} pl={2}>
              {hostName(nodeDetails.id)}
            </Typography>
            <Typography variant='h5' p={1} pl={2}>
              {nodeDetails.description}
            </Typography>
            {nodeDetails.update && (
              <Alert
                icon={<WarningIcon style={{color: 'black'}} />}
                severity='warning'
                sx={{backgroundColor: theme.palette.grey[100]}}
              >
                <AlertTitle>
                  <b>Update</b>
                </AlertTitle>
                {nodeDetails.update.summary}
              </Alert>
            )}
            {nodeDetails.steps.length > 1 && (
              <Box bgcolor={theme.palette.grey[200]} width={'100%'} mt={2} mb={2}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant='scrollable'
                  scrollButtons
                  TabScrollButtonProps={{
                    style: {color: 'black'},
                  }}
                  TabIndicatorProps={{
                    style: {display: 'none'},
                  }}
                >
                  {nodeDetails.steps.map((x, index) => (
                    <Tab
                      sx={{textAlign: 'left', pl: 0}}
                      label={
                        <Typography
                          textAlign='left'
                          color={value === index ? 'primary' : 'black'}
                          variant='h5'
                        >{`Step ${index}`}</Typography>
                      }
                      key={x.step.desc + '-Tab'}
                    />
                  ))}
                </Tabs>
              </Box>
            )}
            <Box px={2} pb={2}>
              {nodeDetails.steps.map((x, index) => (
                <React.Fragment key={x.step.desc}>
                  {nodeDetails.steps.length > 1 ? (
                    <TabPanel tabId={x.step.desc} index={index} value={value}>
                      <Typography variant='h5' p={0.5} mb={2}>{`Step ${index}: ${x.step.desc}`}</Typography>
                      <StepDetailsPanel stepDetails={x} storybook={storybook} />
                    </TabPanel>
                  ) : (
                    <StepDetailsPanel stepDetails={x} storybook={storybook} />
                  )}
                </React.Fragment>
              ))}
            </Box>
          </>
        ) : (
          <Box width='100%' height='80%' display='flex' alignItems='center' justifyContent='center'>
            <EmptyState
              icon={<Close color='primary' fontSize='medium' />}
              title='Data not defined'
              subtitle=' Try a different step'
            />
          </Box>
        )}
      </Box>
    </div>
  );
};

export default StepDetailsPopUp;
